export default __webpack_public_path__ + "static/media/logo.e38a3067.png";